import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { FAQS } from '@/mocks/anime';

// FAQPage 结构化数据（与页面正文问答完全对应）
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionTitle
          eyebrow="答疑解惑"
          title="常见问题"
          desc="关于卡通动漫第一页的使用方法、收藏方式与反馈渠道，我们都为你整理好了。"
        />

        <div className="mt-10 space-y-3 md:mt-14">
          {FAQS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <Reveal key={item.q} delay={i * 50}>
                <div className={`overflow-hidden rounded-2xl border transition-colors ${isOpen ? 'border-primary-300 bg-primary-100/30' : 'border-background-200 bg-background-100/60'}`}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-heading text-base text-foreground-950">{item.q}</h3>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${isOpen ? 'rotate-180 bg-primary-500 text-background-50' : 'bg-background-200/70 text-foreground-600'}`}>
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-7 text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}